import ReportsTab from './Reports';
import UtilitiesTab from './Utilities';
import "../assets/AllTabsCommon.css";



function Repository ({ tab, userInfo, role, filterState, onLoadingStateChange, onRefreshReady, preselectedAdId }) {

    switch (tab) {
        case "Telemetry":
            return <ReportsTab userInfo={userInfo} role={role} filterState={filterState} onLoadingStateChange={onLoadingStateChange} onRefreshReady={onRefreshReady} />;
        case "Utilities":
            return <UtilitiesTab userInfo={userInfo} role={role} preselectedAdId={preselectedAdId} />;
        default:
            return <div className='tab-content'>Content for {tab}</div>;
    }
}

export default Repository;
